import { getApiClientBack } from "../api/api";

function ensureTrailingSlash(u) {
  if (!u) return "";
  return u.endsWith("/") ? u : u + "/";
}

async function obtenerConfigMatomo() {
  const api = await getApiClientBack();

  try {
    const response = await api.get("/matomo");
    return response.data;
  } catch (error) {
    console.error(
      "Error al obtener configuración Matomo:",
      error.response?.data?.message || error.message
    );
    throw new Error(
      error.response?.data?.message || "Error obteniendo configuración Matomo"
    );
  }
}

export async function initMatomo() {
  if (window.__MATOMO_INITED__) return;

  const cfg = await obtenerConfigMatomo();

  var _paq = window._paq || [];
  window._paq = _paq;

  _paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
  _paq.push(["setCookieDomain", cfg.matomoCookie]);
  _paq.push(["trackPageView"]);
  _paq.push(["enableLinkTracking"]);
  _paq.push(["setDownloadClasses", "download"]);
  _paq.push(["alwaysUseSendBeacon"]);

  (function () {
    var u = ensureTrailingSlash(cfg.matomoUrl);
    _paq.push(["setTrackerUrl", u + "matomo.php"]);
    _paq.push(["setSiteId", "" + cfg.matomoId]);

    var d = document,
      g = d.createElement("script"),
      s = d.getElementsByTagName("script")[0];

    g.type = "text/javascript";
    g.async = true;
    g.defer = true;
    g.src = u + "matomo.js";
    s.parentNode.insertBefore(g, s);
  })();

  window.__MATOMO_INITED__ = true;
}

export function trackPageView() {
  var _paq = window._paq || [];
  window._paq = _paq;

  _paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
  _paq.push(["trackPageView"]);
}